import { CIcon } from '~/icons/types'

export const ciHeading2: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 4.5A1.5 1.5 0 0 0 10.5 6v4.5h-5V6a1.5 1.5 0 1 0-3 0v12a1.5 1.5 0 1 0 3 0v-4.5h5V18a1.5 1.5 0 1 0 3 0V6A1.5 1.5 0 0 0 12 4.5Zm9 12h-2.015c.246-.258.585-.466 1.017-.732.995-.613 2.498-1.539 2.498-3.769 0-1.203-.692-2.297-1.806-2.854-1.401-.7-3.117-.455-4.595.653a1.5 1.5 0 0 0 1.801 2.4c.646-.485 1.186-.503 1.452-.37.068.034.148.091.148.171 0 .492-.12.63-1.071 1.215-1.167.72-2.929 1.804-2.929 4.785a1.5 1.5 0 0 0 1.5 1.5h4a1.5 1.5 0 0 0 0-3Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'heading-2',
  type: 'solid'
}
